import React from 'react';
import type { IssueId } from '@atlassian/jira-shared-types/src/general.tsx';

// Unused props are used purely by custom component consumers
type APIProps = {
	id: IssueId;
};

type Props = APIProps;

const ListItemContent = ({ id }: Props) => <span>Issue {id}</span>;

export default ListItemContent;
export type { APIProps };
